<template>
  <div class="paper">
    <div v-if="!isRule" class="paper-main">
      <div class="contain">
        <div class="common">
          <!-- 搜索 -->
          <div class="top clearfix">
            <div class="fl">
              <span>搜索：</span>
              <el-input
                class="searchkey-input-com"
                placeholder="请输入关键字"
                v-model="searchKey"
                size="small"
                @change="selectLsit(1)"
                clearable
              >
              </el-input>
              学科：
              <el-select
                class="xueke-class"
                clearable
                filterable
                v-model="searchSubject"
                size="small"
                @change="selectLsit(1)"
              >
                <template v-for="i of subjectOptions">
                  <el-option
                    :key="i.id"
                    :label="i.disciplineName"
                    :value="i.disciplineCode"
                  ></el-option>
                </template>
              </el-select>
              年级：
              <el-select
                class="xueke-class"
                filterable
                clearable
                v-model="searchClass"
                size="small"
                @change="selectLsit(1)"
              >
                <template v-for="i of classOptions">
                  <el-option
                    :key="i.id"
                    :label="i.gradeName"
                    :value="i.grade"
                  ></el-option>
                </template>
              </el-select>
              公开：
              <el-select
                clearable
                v-model="searchOpen"
                class="open"
                size="small"
                @change="selectLsit(1)"
              >
                <template>
                  <el-option :key="0" label="否" :value="false"></el-option>
                  <el-option :key="1" label="是" :value="true"></el-option>
                </template>
              </el-select>
            </div>
            <div class="fr">
              <!-- <el-button
                size="small"
                icon="iconfont icon-daochu"
                @click="importTeacher"
                v-if="isAdmin"
              >导出</el-button> -->
              <el-button
                size="small"
                icon="iconfont icon-add"
                @click="showAddPop"
                >新增</el-button
              >
              <!-- <icon-integral-rule
                :isRule="isRule"
                @openRule="isRule=true"
              ></icon-integral-rule> -->
            </div>
          </div>
          <!-- 表格 -->
          <el-table
            element-loading-text="拼命加载中..."
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255, 255, 255, 0.9)"
            v-loading="isTableLoading"
            row-key="id"
            :data="tableData"
            stripe
            style="width: 100%"
            :header-cell-style="{ background: '#EFEFEF' }"
          >
            <el-table-column prop="schoolYear" label="学年" width="60">
            </el-table-column>
            <el-table-column prop="schoolTermDesc" label="学期" width="100">
            </el-table-column>
            <el-table-column prop="teacherName" label="教师姓名">
            </el-table-column>
            <el-table-column prop="planName" label="教案名称">
            </el-table-column>
            <el-table-column prop="gradeName" label="年级"> </el-table-column>
            <el-table-column prop="disciplineName" label="学科">
            </el-table-column>
            <el-table-column label="是否公开">
              <template slot-scope="scope">
                {{ scope.row.open ? "是" : "否" }}
              </template>
            </el-table-column>
            <el-table-column label="附件" width="60">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="
                    showImg(
                      scope.row.planAttaches[0].url,
                      '研修成果-课题',
                      scope.row.planAttaches
                    )
                  "
                  >查看</el-button
                >
              </template>
            </el-table-column>
            <el-table-column label="操作" width="150">
              <template slot-scope="scope">
                <el-button
                  :disabled="isDisabled(scope)"
                  type="text"
                  class="text-edit"
                  @click="showEdit(scope.$index, scope.row)"
                  >编辑</el-button
                >|
                <el-button
                  :disabled="isDisabled(scope)"
                  type="text"
                  class="text-del"
                  @click="showDelPop(scope.$index, scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <pagination
            :pageObj="pageObj"
            @handleSizeChange="handleSizeChange"
            @handleCurrentChange="handleCurrentChange"
          ></pagination>
          <!-- 删除的对话框 -->
          <popup-del
            :delVisible="delVisible"
            @close="closePopupDel"
          ></popup-del>

          <!--新增的对话框 -->
          <el-dialog
            class="add-pop"
            :visible.sync="addVisible"
            :close-on-click-modal="false"
            width="40%"
            top="5%"
          >
            <template v-slot:title>
              <div class="add-title">{{ form.id ? "编 辑" : "新 增" }}</div>
            </template>
            <!-- 对话框内容部分 => 匿名插槽 -->
            <el-form ref="form" :rules="rules" :model="form" label-width="80px">
              <el-form-item label="学年" prop="schoolYear">
                <el-date-picker
                  class="width-form-input"
                  v-model="form.schoolYear"
                  value-format="yyyy"
                  type="year"
                  placeholder="请选择"
                >
                </el-date-picker>
              </el-form-item>

              <el-form-item label="学期" prop="schoolTerm">
                <el-select v-model="form.schoolTerm" placeholder="请选择">
                  <template v-for="i of dic.schoolTerm">
                    <el-option
                      :key="i.id"
                      :label="i.dicName"
                      :value="i.dicCode"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="年级" prop="grade">
                <el-select v-model="form.grade" placeholder="请选择">
                  <template v-for="i of classOptions">
                    <el-option
                      :key="i.id"
                      :label="i.gradeName"
                      :value="i.grade"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="学科" prop="disciplineCode">
                <el-select v-model="form.disciplineCode" placeholder="请选择">
                  <template v-for="i of subjectOptions">
                    <el-option
                      :key="i.id"
                      :label="i.disciplineName"
                      :value="i.disciplineCode"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <!-- 教师姓名 -->
              <el-form-item label="教师姓名" prop="teacherId">
                <el-select
                  v-model="form.teacherId"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="请输入教师姓名关键字"
                  :remote-method="teacherKeyChange"
                  :loading="teacherLoading"
                >
                  <el-option
                    v-for="item in teacherOptions"
                    :key="item.id"
                    :label="
                      item.teacherNum
                        ? item.userName + '(师训号:' + item.teacherNum + ')'
                        : item.userName
                    "
                    :value="item.userId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="教案名称" prop="planName">
                <el-input
                  placeholder="请输入"
                  v-model="form.planName"
                ></el-input>
              </el-form-item>
              <el-form-item prop="open" label="是否公开">
                <el-radio-group v-model="form.open">
                  <el-radio size="small" :label="true">是</el-radio>
                  <el-radio size="small" :label="false" class="radio-warning"
                    >否</el-radio
                  >
                </el-radio-group>
              </el-form-item>
              <el-form-item label="上传附件" prop="planAttaches">
                <template>
                  <upload
                    :limit="10"
                    v-if="addVisible"
                    :allowType="1"
                    :fileLimit="50"
                    :fileList="form.planAttaches"
                    :fileUrl="form.planAttach"
                    @uploadFileUrl="uploadFileUrl"
                  ></upload>
                </template>
              </el-form-item>
            </el-form>

            <template v-slot:footer>
              <span class="dialog-footer">
                <el-button @click="submitStudent" type="primary"
                  >提 交</el-button
                >
              </span>
            </template>
          </el-dialog>

          <!-- 审核框 -->
          <el-dialog
            class="add-pop"
            :visible.sync="checkVisible"
            :close-on-click-modal="false"
            width="40%"
            top="20%"
          >
            <template v-slot:title>
              <div class="add-title">审 核</div>
            </template>

            <el-form
              ref="checkForm"
              :model="checkForm"
              label-width="80px"
              :rules="checkRulesList"
            >
              <el-form-item prop="checkStatus" label="审核结果">
                <el-radio-group v-model="checkForm.checkStatus">
                  <el-radio border size="small" label="1">通过</el-radio>
                  <el-radio border size="small" label="2" class="radio-warning"
                    >驳回</el-radio
                  >
                </el-radio-group>
              </el-form-item>
              <el-form-item label="审核意见" prop="checkDesc">
                <el-input
                  type="textarea"
                  v-model="checkForm.checkDesc"
                ></el-input>
              </el-form-item>
            </el-form>

            <template v-slot:footer>
              <span class="dialog-footer">
                <el-button @click="submitCheck" type="primary">提 交</el-button>
              </span>
            </template>
          </el-dialog>

          <!-- 图片预览弹框 -->
          <ViewImg :img-path-list="imgPathList" :is-show.sync="imgVisible" />
        </div>
      </div>
    </div>
    <div v-else>
      <integral-rule-view @closeRule="isRule = false"></integral-rule-view>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import PopupDel from "@/components/PopupDel.vue";
import IconIntegralRule from "@/components/IconIntegralRule.vue";
import IntegralRuleView from "@/components/IntegralRuleView.vue";
import Pagination from "@/components/Pagination.vue";
import Upload from "@/components/Upload.vue";
import { teacherKeyChange, exportExecl } from "@/utils/index";
import { mapState } from "vuex";
import { mixin } from "@/mixin/mixin";
import ViewImg from "@/components/ViewImg.vue";
export default {
  mixins: [mixin],
  components: {
    Breadcrumb,
    PopupDel,
    IconIntegralRule,
    IntegralRuleView,
    Upload,
    Pagination,
    ViewImg,
  },
  computed: {
    ...mapState([
      "isAdmin",
      "userInfo",
      "dic",
      "teacherOptions",
      "teacherLoading",
      "ruleOptions",
    ]),
    checkRulesList: function () {
      if (this.checkForm.checkStatus == "2") {
        return this.checkRulesErr;
      } else {
        return this.checkRulesOk;
      }
    },
  },
  created() {
    this.getDicClass();
    this.getDicSubject();
  },
  data() {
    return {
      searchKey: "",
      searchClass: "",
      searchSubject: "",
      searchOpen: "", //公开 0 否  1 是
      classOptions: "",
      subjectOptions: "",

      imgVisible: false,
      imgUrl: "",
      form: {
        open: "",
        disciplineCode: "",
        disciplineName: "",
        grade: "",
        gradeName: "",
        checkStatus: "0", //0：待审，1：通过，2：不通过
        planName: "",
        planDate: "",
        planAttach: "", //附件
        planAttaches: [], //附件
      },
      checkForm: {
        checkStatus: "",
        checkDesc: "",
      },
      checkRulesErr: {
        checkStatus: [
          {
            required: true,
            message: "请选择审核结果",
          },
        ],
        checkDesc: [
          {
            required: true,
            message: "请输入审核意见",
            trigger: ["change", "blur"],
          },
        ],
      },
      checkRulesOk: {
        checkStatus: [
          {
            required: true,
            message: "请选择审核结果",
            trigger: ["change", "blur"],
          },
        ],
      },
      rules: {
        planAttaches: [
          {
            required: true,
            message: "请上传附件",
            trigger: ["change", "blur"],
          },
        ],
        disciplineCode: [
          {
            required: true,
            message: "请选择学科",
            trigger: ["change", "blur"],
          },
        ],
        grade: [
          {
            required: true,
            message: "请选择年级",
            trigger: ["change", "blur"],
          },
        ],
        open: [
          {
            required: true,
            message: "请选择是否公开教案",
            trigger: ["change", "blur"],
          },
        ],
        planName: [
          {
            required: true,
            message: "请输入教案名称",
            trigger: ["change", "blur"],
          },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: ["change", "blur"],
          },
        ],
      },
    };
  },
  methods: {
    // 年级字典
    getDicClass() {
      const paramsDicClass = {
        clientPackage: "com.xueduoduo.teacher.archives.pc",
        schoolCode: this.userInfo.schoolCode,
        pageSize: 20,
      };
      this.$axios.post("/user/listGrade", paramsDicClass).then((res) => {
        if (res.data.records && res.data.records.length > 0) {
          this.classOptions = res.data.records;
        }
      });
    },
    //学科
    getDicSubject() {
      const paramsDicSubject = {
        clientPackage: "com.xueduoduo.teacher.archives.pc",
        schoolCode: this.userInfo.schoolCode,
        pageSize: 30,
      };
      this.$axios.post("/user/listDiscipline", paramsDicSubject).then((res) => {
        if (res.data.records && res.data.records.length > 0) {
          this.subjectOptions = res.data.records;
        }
      });
    },
    //首页 查询首页list
    selectLsit(curPage, pageSize) {
      let homeForm = {
        schoolCode: this.userInfo.schoolCode,
        clientPackage: "com.xueduoduo.teacher.archives.pc",
        pageNum: curPage || this.pageObj.current,
        pageSize: pageSize || this.pageObj.size,
        keyword: this.searchKey || "",
        // schoolTerm: this.searchTerm || "",
        // schoolYear: this.searchYear || "",
        open: this.searchOpen,
        disciplineCode: this.searchSubject || "",
        grade: this.searchClass || "",
        isAdmin: this.isAdmin / 1,
        operatorId: this.userInfo.userId,
      };
      this.isTableLoading = true;
      this.$axios
        .post("/teacherResearch/getResearchPlanList", homeForm)
        .then((res) => {
          if (res.resultCode === 200) {
            this.pageObj.size = res.data.size;
            this.pageObj.current = res.data.current;
            this.pageObj.total = res.data.total;
            this.tableData = res.data.records;
          } else {
            this.$message({
              message: "数据获取失败",
              type: "error",
            });
          }
          this.isTableLoading = false;
        })
        .catch((err) => {
          console.log("教师error", err);
        });
    },
    //导出
    // importTeacher() {
    //   exportExecl(
    //     "/exp/expResearchTopicsInfo",
    //     "研修成果-优秀教案",
    //     this.userInfo.schoolCode,
    //     this.pageObj.current,
    //     this.pageObj.size,
    //     this.searchYear,
    //     this.searchTerm,
    //     this.searchKey
    //   );
    // },
    // 删除弹框 关闭
    async closePopupDel(status) {
      try {
        !status && (this.delVisible = false);
        if (status) {
          let del = {
            clientPackage: "com.xueduoduo.teacher.archives.pc",
            id: this.selectRow.id,
            operatorId: this.userInfo.userId,
          };
          let { resultCode, msg } = await this.$axios.post(
            "/teacherResearch/deleteTeacherResearchPlan",
            del
          );
          if (resultCode === 200) {
            this.selectLsit(this.pageObj.current, this.pageObj.size),
              this.$message.success("删除成功");
          } else {
            this.$message.error(msg);
          }
          this.delVisible = false;
        }
      } catch (err) {
        console.log("err", err);
      }
    },
    //编辑
    showEdit(index, row) {
      this.selectRow = row;
      //重置效验样式
      this.$refs.form && this.$refs.form.resetFields();
      //查询教师的选择
      this.teacherKeyChange(row.teacherName);
      this.form = {
        id: row.id,
        schoolYear: row.schoolYear + "",
        schoolTerm: row.schoolTerm + "",
        teacherId: row.teacherId,
        teacherName: row.teacherName,
        open: row.open,
        disciplineCode: row.disciplineCode,
        disciplineName: row.disciplineName,
        grade: row.grade,
        gradeName: row.gradeName,
        checkStatus: "0", //0：待审，1：通过，2：不通过
        planName: row.planName,
        planDate: row.planDate,
        planAttach: row.planAttach, //附件
        planAttaches: row.planAttaches, //附件
      };
      this.addVisible = true;
    },
    // 新增
    showAddPop() {
      //清空form表单
      this.form = {
        id: "",
        schoolYear: "",
        schoolTerm: "",
        teacherId: "",
        teacherName: "",
        open: "",
        disciplineCode: "",
        disciplineName: "",
        grade: "",
        gradeName: "",
        checkStatus: "0", //0：待审，1：通过，2：不通过
        planName: "",
        planDate: "",
        planAttach: "", //附件
        planAttaches: [], //附件
      };
      this.$refs.form && this.$refs.form.resetFields();
      this.addVisible = true;
    },
    //新增 或者 更新
    submitStudent() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.id) {
            //更新
            this.form.operatorId = this.userInfo.userId;
            this.form.schoolCode = this.userInfo.schoolCode;
            let subjectObj = this.subjectOptions.find(
              (item) => item.disciplineCode === this.form.disciplineCode
            );
            this.form.disciplineName = subjectObj.disciplineName;

            let classObj = this.classOptions.find(
              (item) => item.grade === this.form.grade
            );
            this.form.gradeName = classObj.gradeName;
            this.$axios
              .post("/teacherResearch/updateTeacherResearchPlan", this.form)
              .then((res) => {
                if (res.resultCode === 200) {
                  //重置表单
                  this.$refs.form.resetFields();
                  this.selectLsit(this.pageObj.current, this.pageObj.size);
                  this.$message({
                    message: "更新成功",
                    type: "success",
                    duration: 2000,
                    offset: 150,
                  });
                } else {
                  console.log("update else", res);
                }
                this.addVisible = false;
              })
              .catch((err) => {
                console.log("update error", err);
              });
          } else {
            //保存
            this.form.operatorId = this.userInfo.userId;
            this.form.schoolCode = this.userInfo.schoolCode;
            let subjectObj = this.subjectOptions.find(
              (item) => item.disciplineCode === this.form.disciplineCode
            );
            this.form.disciplineName = subjectObj.disciplineName;

            let classObj = this.classOptions.find(
              (item) => item.grade === this.form.grade
            );
            this.form.gradeName = classObj.gradeName;
            this.$axios
              .post("/teacherResearch/saveTeacherResearchPlan", this.form)
              .then((res) => {
                if (res.resultCode === 200) {
                  //重置表单
                  this.$refs.form.resetFields();
                  this.selectLsit(this.pageObj.current, this.pageObj.size);
                  this.$message({
                    message: "保存成功",
                    type: "success",
                    duration: 2000,
                    offset: 150,
                  });
                } else {
                  this.$message({
                    message: res.msg,
                    type: "error",
                    duration: 2000,
                    offset: 150,
                  });
                }
                this.addVisible = false;
              })
              .catch((err) => {
                console.log("update error", err);
              });
          }
        }
      });
    },
    //显示审核框
    showCheckEdit(index, row, status) {
      //教师不具有操作权限，，通过，，驳回，也不能操作
      if (!this.isAdmin || status == "1" || status == "2") {
        return;
      }

      this.selectRow = row;
      this.checkForm = {
        checkStatus: "",
        checkDesc: "",
      };
      this.$refs.checkForm && this.$refs.checkForm.resetFields();
      this.checkVisible = true;
    },
    //审核
    submitCheck() {
      this.$refs.checkForm.validate((valid) => {
        if (valid) {
          let checkPost = {
            clientPackage: "com.xueduoduo.teacher.archives.pc",
            checkDesc: this.checkForm.checkDesc,
            checkStatus: this.checkForm.checkStatus,
            checkId: this.userInfo.userId,
            id: this.selectRow.id,
            operatorId: this.userInfo.userId,
            checkName: this.userInfo.userName,
          };
          this.$axios
            .post("/teacherResearch/checkTeacherResearchInfo", checkPost)
            .then((res) => {
              if (res.resultCode == "200") {
                this.selectLsit(this.pageObj.current, this.pageObj.size);
                this.$message.success("更改成功");
              } else {
                this.$message.error(res.msg);
              }
              this.checkVisible = false;
            })
            .catch((err) => {
              this.$message.error(res.msg);
            });
        }
      });
    },
    //资源路径
    uploadFileUrl(fileUrl, fileList) {
      this.form.planAttaches = fileList;
      this.form.planAttach = fileUrl;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../../styles/common.less";
.fl {
  width: calc(100% - 100px) !important;
  max-width: 1000px !important;
  .searchkey-input-com {
    margin-right: 10px !important;
  }
  .xueke-class {
    margin-right: 10px !important;
  }
  .open {
    width: 120px !important;
  }
}
</style>


